import _ from 'lodash'
import FileSaver from 'file-saver'
import api from '@/api/api'
import moment from 'moment-timezone'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import DateField from '@/components/general/fields/date/date'

export default {
	name: 'reports-potential',
	data () {
		return {
			contracts : [],
			filters : {
				since : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : '',
					value     : '',
					name      : this.$t('private.reports.master_data.filters.since'),
					error     : false,
					active    : false,
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				until : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : '',
					value     : '',
					name      : this.$t('private.reports.master_data.filters.until'),
					error     : false,
					active    : false,
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				limit : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : this.$t('private.reports.master_data.filters.limit_options.10'),
					value     : 10,
					name      : this.$t('private.reports.master_data.filters.limit'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.reports.master_data.filters.limit_options.10'),
						value : 10
					},{
						fakeValue : this.$t('private.reports.master_data.filters.limit_options.25'),
						value : 25
					},{
						fakeValue : this.$t('private.reports.master_data.filters.limit_options.50'),
						value : 50
					},{
						fakeValue : this.$t('private.reports.master_data.filters.limit_options.100'),
						value : 100
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				skip : {
					value : 0
				}
			},
			groupings : {
				id        : _.uniqueId('field_'),
				display   : true,
				fakeValue : 'Ningúno',
				value     : 0,
				name      : this.$t('private.reports.master_data.groupings.name'),
				error     : false,
				active    : false,
				options : [{
				fakeValue : 'Ninguno',
				value : 0
				},{
				fakeValue : this.$t('private.reports.master_data.groupings.codeClient'),
				value : 1
				},{
				fakeValue : this.$t('private.reports.master_data.groupings.legal_name'),
				value : 2
				},{
				fakeValue : this.$t('private.reports.master_data.groupings.seller'),
				value : 3
				}]
			},
			getContractsActive : false,
			activateFilters : false,
			haveData : false,
			nextPage : false,
      exportDataActive : false,
      groupingsActive : false,
      contractsGroupsByCodeClient : [],
      contractsGroupsByLegalName : [],
      contractsGroupsBySeller : []
		}
	},
	methods : {
		getContracts () {

			let vm = this

			vm.getContractsActive = true
      vm.contracts = []

			let since = vm.filters.since.value ? moment(vm.filters.since.value).startOf('day').toDate() : '' ;
			let until = vm.filters.until.value ? moment(vm.filters.until.value).endOf('day').toDate() : '' ;

			let dataToSend =
				'/?state='     + 0                            +
				'&descending=' + 'appCreationDate'            +
        '&exported='   + true                         +
				'&since='      + since                        +
				'&until='      + until                        +
				'&limit='      + (vm.filters.limit.value + 1) +
				'&skip='       + vm.filters.skip.value

			api
				.contracts
				.getContracts(dataToSend)
				.then( (response) => {

					vm.getContractsActive = false

					if( response.status != 200 ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					if( !response.data.success ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					vm.contracts = response.data.contracts

					if( vm.contracts.length > 0 && !vm.haveData ){

						vm.haveData = true

					}

					if( vm.contracts.length > vm.filters.limit.value ){

						vm.nextPage = true

						vm.contracts.pop()

					}else{

						vm.nextPage = false

					}

          vm.activateGroupings()

				})

		},
		goToBackPage () {

			let vm = this

			if( vm.filters.skip.value != 0 ){

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

				vm.getContracts()

			}

		},
		goToNextPage () {

			let vm = this

			if( vm.nextPage ){

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

				vm.getContracts()

			}

		},
		exportData () {

			let vm = this

			let dataToSend = {
				headers : [
					vm.$t("private.reports.potential.table.client"),
					vm.$t("private.reports.potential.table.legal_name"),
					vm.$t("private.reports.potential.table.seller"),
					vm.$t("private.reports.potential.table.employees_quantity"),
					vm.$t("private.reports.potential.table.wella_potential"),
					vm.$t("private.reports.potential.table.nioxin_potential"),
					vm.$t("private.reports.potential.table.sp_potential"),
					vm.$t("private.reports.potential.table.sassoon_potential"),
					vm.$t("private.reports.potential.table.sebastian_potential"),
					vm.$t("private.reports.potential.table.sp_diamond_potential"),
					vm.$t("private.reports.potential.table.opi_potential")
				],
        timeZone: moment.tz.guess()
			}

			console.log('moment.tz.guess()', moment.tz.guess())

      vm.exportDataActive = true
			api
				.reports
				.exportPotential(dataToSend)
				.then( (response) => {

					vm.getContractsActive = false

          vm.exportDataActive   = false

					if( response.status != 200 ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					let file    = new Blob([response.data], { type : 'application/vnd.ms-excel' })
					let fileURL = URL.createObjectURL(file)

					FileSaver.saveAs(file, 'potential.xlsx')

					vm.getContracts()

				})

		},
    activateGroupings(){

      let vm = this

      vm.groupingsActive = vm.groupings.value == 0 ? false : true

      if( vm.groupings.value == 0 ){

        vm.contracts = _.orderBy(vm.contracts, ['appCreationDate'], ['desc'])

      }

      if(vm.groupings.value == 1) {

        vm.contracts = _.orderBy(vm.contracts, ['client.clientCode', 'appCreationDate'], ['asc', 'desc'])
        vm.contractsGroupsByCodeClient = _.groupBy(vm.contracts, 'client.clientCode')

        console.log('vm.contractsGroupsByCodeClient ', vm.contractsGroupsByCodeClient)

      }

      if(vm.groupings.value == 2) {

        vm.contracts = _.orderBy(vm.contracts, ['client.legalName', 'appCreationDate'], ['asc', 'desc'])
        vm.contractsGroupsByLegalName = _.groupBy(vm.contracts, 'client.legalName')
      }

      if(vm.groupings.value == 3) {

        vm.contracts = _.orderBy(vm.contracts, ['seller.username', 'appCreationDate'], ['asc', 'desc'])
        vm.contractsGroupsBySeller = _.groupBy(vm.contracts, 'seller.username')
      }

    },
	},
	components : {
		MenuMoreOptions,
		TextField,
		SelectField,
		CheckboxField,
		DateField
	},
	created () {

		let vm = this

		vm.getContracts()

	}
}



// WEBPACK FOOTER //
// ./src/components/private/reports/potential/script.js